import { render, staticRenderFns } from "./Aparelhos.vue?vue&type=template&id=1432974e&scoped=true"
import script from "./Aparelhos.vue?vue&type=script&lang=js"
export * from "./Aparelhos.vue?vue&type=script&lang=js"
import style0 from "./Aparelhos.vue?vue&type=style&index=0&id=1432974e&prod&lang=scss&scoped=true"
import style1 from "./Aparelhos.vue?vue&type=style&index=1&id=1432974e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1432974e",
  null
  
)

export default component.exports